<section class="contact" id="contact" aria-labelledby="contact-heading">
  <div class="contact__content">
    <h2 id="contact-heading">{{ 'CONTACT.HEADLINE' | translate }}</h2>
    <p>{{ 'CONTACT.SUBTEXT' | translate }}</p>

    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" aria-label="Kontaktformular" novalidate>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'CONTACT.NAME_LABEL' | translate }}</mat-label>
        <input matInput formControlName="name" placeholder="{{ 'CONTACT.NAME_PLACEHOLDER' | translate }}" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'CONTACT.EMAIL_LABEL' | translate }}</mat-label>
        <input matInput type="email" formControlName="email" placeholder="{{ 'CONTACT.EMAIL_PLACEHOLDER' | translate }}" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'CONTACT.MESSAGE_LABEL' | translate }}</mat-label>
        <textarea matInput rows="5" formControlName="message" placeholder="{{ 'CONTACT.MESSAGE_PLACEHOLDER' | translate }}" required></textarea>
      </mat-form-field>

      <button class="cta-button"  mat-raised-button color="primary" type="submit">
        {{ 'CONTACT.SUBMIT' | translate }}
      </button>
    </form>

    <div class="contact__info">
      <p>{{ 'CONTACT.DIRECT_CONTACT' | translate }}</p>
      <a href="mailto:korkut&#64;cloudfusion-it.de">korkut&#64;cloudfusion-it.de</a>

      <p style="margin-top: 2rem;">
        <a href="https://calendly.com/korkut-cloudfusion-it" target="_blank" rel="noopener" class="cta-button">
          {{ 'CONTACT.BOOK_CALENDLY' | translate }}
        </a>
      </p>
    </div>
  </div>
</section>
